// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__YBSc3","colCheckbox":"styles_colCheckbox__2QL25"};